import { apolloClient, EntityDescriptor, EntityEditorFormSimple } from "@crispico/foundation-react";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { EntityFilterMode } from "@crispico/foundation-react/entity_crud/fieldEditors/FilterFieldEditor";
import React from "react";
import { Button, ModalActions, ModalContent } from "semantic-ui-react";
import { APPLY_FOA_FOR_FLIGHTS } from "../queries";

type FlightAndObjectActionApplyModalProps = {
    initialFlightFilter: Filter,
    foaFilter: Filter | null,
    showModal?: boolean,
    afterClose?: () => void
}

type FlightAndObjectActionApplyModalState = {
    confirmationPhase: boolean,
    showModal: boolean,
    flightFilter: Filter,
}

const APPLY_RULES_ENTITY_DESCRIPTOR = new EntityDescriptor({ name: "ApplyRules" })
    .addFieldDescriptor({ name: "flightFilter", type: FieldType.filter, mode: EntityFilterMode.OBJECT, entityName: "Flight" });

export class FlightAndObjectActionApplyModal extends React.Component<FlightAndObjectActionApplyModalProps, FlightAndObjectActionApplyModalState> {

    protected entityEditorFormSimpleRef = React.createRef<EntityEditorFormSimple>();

    constructor(props: FlightAndObjectActionApplyModalProps) {
        super(props);
        this.state = {
            confirmationPhase: false,
            showModal: props.showModal || false,
            flightFilter: props.initialFlightFilter
        }

        this.onClose = this.onClose.bind(this);
    }

    openModal() {
        this.setState({ showModal: true });
    }

    protected onClose() {
        this.setState({ confirmationPhase: false, showModal: false });
        if (this.props.afterClose) {
            this.props.afterClose();
        }
    }

    render() {
        return <ModalExt open={this.state.showModal} size="small" onClose={this.onClose}
            header={_msg("FlightAndObjectAction.apply.rules.label", _msg("FlightAndObjectAction.label.plural"))}
            content={
                <ModalContent className="FlightAndObjectAction_applyModalContent">
                    {this.state.confirmationPhase ? _msg("FlightAndObjectAction.apply.confirmation.label", _msg("FlightAndObjectAction.label.plural")) :
                        <EntityEditorFormSimple ref={this.entityEditorFormSimpleRef} entity={{ flightFilter: this.state.flightFilter }}
                            entityDescriptor={APPLY_RULES_ENTITY_DESCRIPTOR} hideButtonBar />
                    }
                </ModalContent>
            }
            actions={
                <ModalActions>
                    <Button primary content={_msg(this.state.confirmationPhase ? "general.ok" : "FlightAndObjectAction.apply.label")} onClick={async () => {
                        if (this.state.confirmationPhase) {
                            await apolloClient.mutate({
                                mutation: APPLY_FOA_FOR_FLIGHTS,
                                variables: { flightFilter: this.state.flightFilter, foaFilter: this.props.foaFilter },
                            });

                            this.onClose();
                            return;
                        }
                        this.setState({ confirmationPhase: true, flightFilter: this.entityEditorFormSimpleRef.current?.formik.current?.values["flightFilter"] });
                    }} />
                    <Button content={_msg("general.cancel")} onClick={async () => {
                        this.onClose();
                    }} />
                </ModalActions>
            }
        />
    }

}